import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Box, Button } from '@mui/material';
import { useAuth } from './context/AuthContext';

import PublicPage from './pages/PublicPage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ProtectedRoute from './components/ProtectedRoute';
import SolicitudDetailPage from './pages/SolicitudDetailPage';
import DashboardStatsPage from './pages/DashboardStatsPage';
import HelpPage from './pages/HelpPage';

function App() {
  const { token, logout } = useAuth();

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar position="fixed">
        <Toolbar>
          <Typography variant="h6" component={Link} to="/" sx={{ flexGrow: 1, color: 'inherit', textDecoration: 'none' }}>
            Participación Ciudadana
          </Typography>
          <Button color="inherit" component={Link} to="/ayuda">
            Ayuda
          </Button>
          {token ? (
            <Button color="inherit" onClick={logout}>
              Cerrar Sesión
            </Button>
          ) : (
            <Button color="inherit" component={Link} to="/login">
              Acceso Interno
            </Button>
          )}
        </Toolbar>
      </AppBar>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Toolbar />
        <Routes>
          <Route path="/" element={<PublicPage />} />
          <Route path="/ayuda" element={<HelpPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/dashboard/stats" 
            element={
              <ProtectedRoute>
                <DashboardStatsPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/dashboard/solicitud/:id" 
            element={
              <ProtectedRoute>
                <SolicitudDetailPage />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </Box>
    </Box>
  );
}

export default App;
